var formWrapper;
var pageWrapper;
var listeAdressesWrapper;

$(document).ready(function () {
    /** Objets réutilisés souvent par la suite **/
    pageWrapperSelector = "#main-content";
    pageWrapper = $(pageWrapperSelector);
    
    listeAdressesWrapper = $(".adresse-list");
    adressesListe = $("#adresses-list-espace-client");
    
    initCarnetAdresses();
});


// Comportements à initialiser au chargeent de page ou après chargement ajax des portions de la page
function initCarnetAdresses() {
    formWrapper = $("#adresse-form-wrapper");
    $(".btn-adresse-modifier").off('click').on("click", function (event) {
        event.preventDefault();
        var idAdresse = $(this).attr('data-adresse-id');
        modifierAdresse(idAdresse);
    });
    

    $(".btn-adresse-ajouter").off('click').on("click", function (event) {
        event.preventDefault();
        ajouterAdresse();
    });
}

function OnSuccessModifierAdresse(data) {
    
    if (data.IsValid) {
        updateListeAdresses();
        cacherFormulaireAdresse();
        //afficherFormulaireAdresse(data.Html);
    }
    else {
        afficherFormulaireAdresse(data.Html);
    }
}


function updateListeAdresses() {
    $.ajax({
        url: '/EspaceClient/ListeAdresses',
        data: {},
        success: function (result) {
            
            listeAdressesWrapper.html(result);
            adressesListe.html(result);
            initCarnetAdresses();
        },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}

function supprimerAdresse(id) {
    $('.ajax-modal-small').foundation('reveal', 'open', {
        url: '/EspaceClient/_PopinSuppressionAdresse',
        data: { idAdresse: id },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}

function ajouterAdresse() {
    $.ajax({
        url: '/EspaceClient/AjouterAdresse',
        data: { },
        success: function (result) {
            afficherFormulaireAdresse(result);
            initCarnetAdresses();
        },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}


function modifierAdresse(id) {
    $.ajax({
        url: '/EspaceClient/ModifierAdresse',
        data: { idadresse : id },
        success: function (result) {
            afficherFormulaireAdresse(result);
        },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}

function afficherFormulaireAdresse(result) {
    formWrapper.html(result);
    formWrapper.show();
    unbindFormulaireAdresse();
    bindFormulaireAdresse($('#autre-adresse-form-wrapper'));
    $(document).foundation('scroll', 'moveTo', formWrapper);
}

function cacherFormulaireAdresse(result) {
    $(document).foundation('scroll', 'moveTo', pageWrapper);
    formWrapper.hide();
}

function showPreloader() {
    $(".form-alert-box").hide();
    $('#preloader').show();
}

function hidePreloader() {
    $('#preloader').hide();
}